import { useEffect, useState } from "react";
import useDataBean from "../../../../../../core/services/dataBean/useDataBean";
import { _CashRequestItem, _DocumentFactory, _single, _UBLInvoice } from "../../../../../../core/services/dataBean/EntityCatalog";
import { Singleton } from "../../../../../../core/services/Singleton";
import { FileService } from "../../../../../../core/services/FileService";
import useModal, { MODAL_LG, MODAL_SM, MODAL_XL } from "../../../../../theme/Component/hooks/useModal";
import { BasicTable, MASK_MONEY } from "../../../../../theme/Component/BasicTable";
import { ListMenu } from "../../../../../theme/Component/ListMenu";
import { toast } from "react-toastify";
import { ModalConfirm } from "../../../../../theme/Component/ModalConfirm";
import { Modal } from "../../../../../theme/Component/Modal";
import { FileInput } from "../../../../../theme/Component/FileInput";
import { InputDate } from "../../../../../theme/Input/InputDate";
import { InputMoney } from "../../../../../theme/Input/InputMoney";
import { SelectProject } from "../../../BudgetAccountantOperation/SelectProject";
import { SelectBusinessCore } from "../../../BusinessCore/SelectBusinessCore";
import { DocumentViewer } from "../../../../../theme/Component/DocumentViewer";
import { AccountEditor } from "../../../../../editor/AccountEditor";
import { SeeInvoice } from "../../../CashResquestItems/SeeInovoice";
import { UBLInvoiceSupplier } from "../../../../../contract/etapa-contrato/contrac/UBLInvoiceSupplier/UBLInvoiceSupplier";
import { YearSelector } from "../../../../../../core/shared/inputs/YearSelector";
import { CashDeskAccountSelector } from "../../../CashDeskAccount/CashDeskAccountSelector";
import { RequesItemConstants } from "./RequesItemConstants/RequesItemConstants";
import { BasicButton } from "../../../../../theme/Component/BasicButton";
import usePaginator from "../../../../../theme/Component/usePaginator";
import { BasicPage } from "../../../../../theme/Component/BasicPage";
import { BudgetListForRefund } from "../BudgetListForRefund/BudgetListForRefund";
import { _CreateMoney } from "../../../../../../core/services/dataBean/EntityCatalogVdos";
import { CDPCatalog } from "../../../CashDeskAccount/CashDeskAccountCDP/CDPCatalog/CDPCatalog";
import { ExportXLSL } from "../../../../../theme/Component/ExportXLSX";
import { DropDown } from "../../../../../theme/Component/DropDown";


// interface Props {
//     idCashRequest?: number;
//     cashRequestDate?: any;
//     entry?: "Request" | "Manage";
//     idAccount?: number;
//     updateFunction?: Function;
//     _idCashAccount?: number;
// }


export const CashRequestItemBystate = () => {

    const { lista, setLista, bean, setBean, instance, handleChange } = useDataBean(_CashRequestItem);
    const single = Singleton.getInstance();
    const file = new FileService();
    const [listaAll, setListaAll] = useState<any>([]);
    const [obs, setObs] = useState<string>("");
    const _documentos = useDataBean(_DocumentFactory);
    const [docs, setDocs] = useState<any>([]);
    const _createMoney = useDataBean(_CreateMoney);
    const [legalizar, setlegalizar] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: "modal-xl", });
    const [moneybase, setmoneybase] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: "modal-lg", });
    const [modal, setModal] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: "modal-xl", });
    const [modalConfirm, setModalConfirm] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: "modal-sm", });
    const [modalProcess, setModalProcess] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: "modal-md", });
    const [modalReject, setModalReject] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: "modal-md", });
    const [modalAddToCashReimbursement, setModalAddToCashReimbursement] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: "modal-md", });
    const [modalSeeInvoice, setModalSeeInvoice] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: "modal-lg", });
    const [IDCashDeskAccount, setIDCashDeskAccount] = useState<number>(null)
    const [IdAcoount, setIdAcoount] = useState<number>(null)
    const [state, setstate] = useState<number>(0)
    const [idCashRequest, setidCashRequest] = useState<number>(null)
    const [consultar, setconsultar] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: "modal-lg", });
    const [year, setyear] = useState<any>(_single.getCurrenYear())
    const [listUBL, setListUBL] = useState<any>([]);
    const modalDoc = useModal("Documento Soporte", MODAL_XL);
    const modalAccount = useModal("Contabilizar Factura de Reembolso de Caja", MODAL_SM);
    const modalUBL = useModal("Factura", MODAL_LG);
    const paginador = usePaginator();
    const modalDownload = useModal("Consolidado", MODAL_SM);

    useEffect(() => {
        if (legalizar.view) {
            verDocumentos();
        }
    }, [legalizar.view]);
    useEffect(() => {
        getLista();
    }, [paginador.page])
    const getLista = () => {
        instance.getCashRequestItemCatalogByState(
            year, IdAcoount, IDCashDeskAccount, idCashRequest, state, paginador.page, 15
        ).then((resp: any) => {
            if (resp) {
                paginador.setPages(resp.NumberOfPages);
                paginador.setRecords(resp.NumberOfPages * 15);
                paginador.setRegiPerPage(15);

                let x = resp.List;
                x.forEach(element => {
                    if (element.DataBeanProperties.Media) {
                        const doc = file.getUrlFile(
                            element.DataBeanProperties.MediaContext,
                            element.DataBeanProperties.Media
                        );
                        element.DataBeanProperties.EntityMedia =
                            `<a target='_blank' href='${doc}'>${element.DataBeanProperties.Media}</a>`;
                        element.DataBeanProperties.FCDocument =
                            (element.DataBeanProperties.FCMnemonic ?? '') + " - " +
                            (element.DataBeanProperties.FCConsecutive ?? '') + " " +
                            (element.DataBeanProperties.FCDate ?? '');
                    } else {
                        element.DataBeanProperties.EntityMedia = "Sin Adjunto";
                    }
                });

                setLista(x);
            }
        });
    }
    const getListaAll = () => {
        instance.getCashRequestItemCatalogByState(
            year, IdAcoount, IDCashDeskAccount, idCashRequest, state, 1, 15 * paginador.pages
        ).then((resp: any) => {
            if (resp) {
                paginador.setPages(resp.NumberOfPages);
                paginador.setRecords(resp.NumberOfPages * 15);
                paginador.setRegiPerPage(15);

                let x = resp.List;
                x.forEach(element => {
                    if (element.DataBeanProperties.Media) {
                        const doc = file.getUrlFile(
                            element.DataBeanProperties.MediaContext,
                            element.DataBeanProperties.Media
                        );
                        element.DataBeanProperties.EntityMedia =
                            `<a target='_blank' href='${doc}'>${element.DataBeanProperties.Media}</a>`;
                        element.DataBeanProperties.FCDocument =
                            (element.DataBeanProperties.FCMnemonic ?? '') + " - " +
                            (element.DataBeanProperties.FCConsecutive ?? '') + " " +
                            (element.DataBeanProperties.FCDate ?? '');
                    } else {
                        element.DataBeanProperties.EntityMedia = "Sin Adjunto";
                    }
                });

                setListaAll(x);
            }
        });
    }
    const actionsDropDown = [
        { id: 1, name: 'Descargar Reporte', permiso: null, activo: true },

    ];
    const buttons = () => {
        return (
            <div className="row">
                <div className="col-md-12">
                    <DropDown lista={actionsDropDown} eventClick={(e) => {
                        if (e.id === 1) {
                            getListaAll();
                            modalDownload.open();
                        }
                    }}></DropDown>
                </div>
            </div>
        )
    }
    const createItem = () => {
        setBean({
            IDEmployee: single.getAccountID(),
            // IDCashRequest: idCashRequest,
            // CashRequestDate: cashRequestDate,
            IsUBLDocument: false,
        });
        setModal({ ...modal, "view": true, "name": "Crear una Solicitud de Pago" })
    }

    const createItemRequest = () => {
        instance.importUBLInvoiceToCashRequest(bean.IDCashRequest, bean.CashRequestDate, bean.Media, bean.MediaContext, null, bean.IssueDate, bean.InvoiceID, bean.PaymentValue, bean.Observations, bean.IDProject, bean.IDBusinessCore).then(
            (resp) => {
                getLista();
                setModal({ ...modal, "view": false });

            }
        ).catch(
            err => {
                console.error(err);
            }
        )
    }

    const eliminarItem = () => {
        instance.deleteCashRequestItem(bean.IDCashRequestItem, single.getCurrenDate(), single.getAccountID()).then(
            (resp) => {
                setModalConfirm({ ...modalConfirm, "view": false });
                getLista();
            }
        ).catch(
            err => {
                console.error(err)
            }
        )
    }

    const procesItem = () => {
        instance.processCashRequestItem(bean.IDCashRequestItem, bean.CashRequestDate, single.getAccountID(), obs).then(
            (resp) => {
                setModalProcess({ ...modalProcess, "view": false });
                getLista();
            }
        ).catch(
            err => {
                console.error(err);
            }
        )
    }

    const rejectItem = () => {
        instance.rejectCashRequestItem(bean.IDCashRequestItem, bean.CashRequestDate, single.getAccountID(), obs).then(
            (resp) => {
                setModalReject({ ...modalReject, "view": false });
                getLista();
            }
        ).catch(
            err => {
                console.error(err);
            }
        )
    }

    const head = [
        { title: 'ID', property: 'IDCashRequestItem', visible: true },
        { title: 'Solicitud de Caja Menor', property: 'IDCashRequest', visible: true },
        { title: 'Solicitante', property: 'AccountName', visible: true },
        { title: 'Estado de Legalización', property: 'StateName', visible: true },
        { title: 'Caja Menor', property: 'CashDeskName', visible: true },
        { title: 'Documento de Solicitud', property: 'CashRequestDocument', visible: true },
        { title: 'Descripción', property: 'Description', visible: true },
        { title: 'Archivo de Factura/Solicitud', property: 'EntityMedia' },
        { title: 'Valor Solicitado', property: 'PaymentValue', visible: true },
        { title: 'Proveedor', property: 'SupplierName', visible: true },
        { title: 'Factura Electrónica', property: 'IsUBLDocument', visible: true },
        { title: 'Factura Electrónica', property: 'InvoiceID', visible: true },
        { title: 'Respuesta de Caja', property: 'CashResponse', visible: true },
        { title: 'Responsable de Caja', property: 'IDEmployee', visible: true },
        { title: 'Documento de Reembolso', property: 'CashReimbursementName', visible: true },
        { title: 'Documento de Legalización', property: 'FCDocument', visible: true },
        { title: 'Estado de Legalización', property: 'StateName', visible: true },
    ]

    const iconButtonsItem = [
        { nombre: "Agregar", visible: true, icono: "ri-file-add-line", evento: createItem },
    ];

    const listaBotones = () => {
        const botones = [
            { titulo: "Ver Documento Soporte", icono: "ri-eye-line", visible: true, evento: () => { modalDoc.open(); }, },
            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: single.canEdit(), evento: () => { setModal({ ...modal, "view": true }) } },
            { titulo: "Ver Documento de Legalización", icono: "ri-file-list-line", visible: true, evento: () => { setlegalizar({ ...legalizar, "view": true }) }, },
            { titulo: "Eliminar", icono: "ri-delete-bin-line", visible: true, evento: () => { setModalConfirm({ ...modalConfirm, view: true, name: `Eliminar ${bean.Description}` }); }, },
            { titulo: "Ver Factura Electronica", icono: "ri-eye-line", visible: bean.IDUBLInvoice, evento: () => { setModalSeeInvoice({ ...modalSeeInvoice, view: true, name: `Factura Asociada al Item ${bean.Description}` }); }, },
            { titulo: "Legalizar Rembolso de Caja Menor", icono: "ri-folder-download-line", visible: true, evento: () => { setModalAddToCashReimbursement({ ...modalAddToCashReimbursement, view: true, name: `Legalizar Rembolso de Caja Menor` }); }, },
            { titulo: "Marcar Solicitud Procesada", icono: "ri-check-line", visible: true, evento: () => { setModalProcess({ ...modalProcess, view: true, name: "Marcar Solicitud Procesada" }); }, },
            { titulo: "Rechazar Solicitud", icono: "ri-close-line", visible: true, evento: () => { setModalReject({ ...modalReject, view: true, name: `Rechazar Solicitud` }); }, },
            { titulo: "Contabilizar Factura de Reembolso de Caja", icono: "ri-send-plane-line", visible: true, evento: () => { modalAccount.open(); }, },
        ];
        return <ListMenu listaBotones={botones} />;
    };
    const verDocumentos = () => {

        if (bean.FCIDDocument) {
            _documentos.instance.getPdfAccountantDocument(bean.FCIDDocument, null, bean.FCDate, _single.getAccountID()).then(
                (resp: any) => {
                    console.log(resp);
                    setDocs(resp.DocumentURL);
                    setlegalizar({ ...legalizar, "view": true });
                }
            )
        } else {
            toast.warning("No hay documento asociado");
        }

    }

    const setRowBean = (objeto: any) => {
        setBean(objeto);
    }

    useEffect(() => {
        setObs("");
    }, [modalProcess, modalReject]);

    const [missingFields, setMissingFields] = useState<string[]>([]);

    const validateData = () => {
        if (validateForm() > 0) {
            toast.error("Faltan campos obligatorios por completar");
            return;
        } else {
            createItemRequest();
        }
    }

    const validateForm = () => {
        const requiredFieldsCash = [
            "Media", "IssueDate", "InvoiceID", "PaymentValue", "Observations", "IDProject", "IDBusinessCore"
        ];
        let missing = [];
        for (let field of requiredFieldsCash) {
            if (bean[field] === null || bean[field] === undefined || bean[field] === "") {
                missing.push(field);
            }
        }

        setMissingFields(missing);
        return missing.length
    };

    const [fileType, setFileType] = useState<string>(null);
    const [donwloadURL, setDonwloadURL] = useState<string>(null);
    const [urlFile, setUrlFile] = useState<string | null>(null);

    useEffect(() => {
        if (donwloadURL) {
            const fetchPdf = async () => {
                try {
                    const data = await file.getPdfAsBase642(donwloadURL);
                    setUrlFile(data);
                } catch (error) {
                    console.error('Error loading PDF:', error);
                }
            };

            fetchPdf();
        }
    }, [donwloadURL]);

    useEffect(() => {
        setFileType(bean.Media?.split('.').pop())
        setDonwloadURL(file.getUrlFile(bean.MediaContext, bean.Media))
    }, [bean])

    const [dateAcc, setDateAcc] = useState("");

    const accountUBL = () => {
        instance.createAccountantDocumentForCashRequestItem(bean.IDCashRequestItem, bean.CashRequestDate, dateAcc, single.getAccountID()).then(
            (resp) => {
                modalAccount.close();
                getLista();
                setDateAcc("");
            }
        ).catch(err => { toast.error(err) })
    }

    const createUBLInvoice = () => {
        instance.createUBLInvoiceForCashRequest(bean.IDCashRequestItem, bean.CashRequestDate, bean.IDAccountSupplier, bean.IDBusinessCore, bean.IDProject).then(
            (resp) => {
                console.log(resp);

                setModalAddToCashReimbursement({ ...modalAddToCashReimbursement, view: false });
                getLista();
                ubl.setBean(resp);
                modalUBL.open();
                let tmp = [];
                tmp.push({ DataBeanProperties: resp });
                setListUBL(tmp);
            }
        ).catch(
            err => { toast.error(err) }
        )
    }

    const ubl = useDataBean(_UBLInvoice);

    const updateInvoice = () => {
        ubl.instance.updateUBLInvoice(ubl.bean).then(
            (resp) => {
                modalUBL.close();
            }
        ).catch(
            err => { console.log(err) }
        )
    }
    const vervalorespendientes = () => {
        setconsultar({ ...consultar, view: true });
    }
    const createmoneybase = () => {
        setmoneybase({ ...moneybase, view: true });
    }
    const createMoneyBaseForCashDeskAccount = () => {
        _createMoney.instance.createMoneyBaseForCashDeskAccount(_createMoney.bean.IDCashDeskAccount, _createMoney.bean.IDCashDeskAccountCDP, _createMoney.bean.Observations, _createMoney.bean.AccountantDate, _single.getAccountID()).then(
            (resp) => {
                console.log(resp)
                toast.success('Creado')
                setmoneybase({ ...moneybase, view: false });
            }
        ).catch(
            err => {
                console.error(err)
            }
        )
    }


    return (
        <>
            <div className="row">
                <div className="col-md-12">

                    <BasicPage titulo="Legalizar Facturas de Caja Menor">

                        <div className="row">
                            <div className="col-md-4">
                                <YearSelector value={year} onChange={(e) => { setyear(e) }} />
                            </div>
                            <div className="col-md-4">
                                <AccountEditor label="Solicitante" idAccount={IdAcoount} onChange={(e) => { setIdAcoount(e.IDAccount) }} />
                            </div>
                            <div className="col-md-4">
                                <CashDeskAccountSelector id={IDCashDeskAccount} onchange={(e) => { setIDCashDeskAccount(e) }} />
                            </div>
                            <div className="col-md-4">
                                <RequesItemConstants idSelector={state} onChange={(e) => { setstate(e) }} />
                            </div>
                            <div className="col-md-4">
                                <label>Solicitud de Caja Menor:</label>
                                <input type='number' className='form-control' value={idCashRequest} onChange={(e) => setidCashRequest(parseInt(e.target.value))} />
                            </div>
                            <div className="col-md-4 mt-4 p-2">
                                <BasicButton icon='ri-search-line' eventClick={() => { getLista() }} >Buscar </BasicButton>
                            </div>
                            <div className="row">
                                <div className="col-md-6 mt-4">
                                    <BasicButton icon='ri-search-line' eventClick={() => { vervalorespendientes() }} >Consultar Valores Pendientes de Reembolso </BasicButton>
                                </div>
                                <div className="col-md-6 mt-4">
                                    <BasicButton icon='ri-stack-line' eventClick={() => { createmoneybase() }} >Constituir Caja Menor </BasicButton>
                                </div>
                            </div>

                            <div className="col-md-12">
                                <BasicTable
                                    headButtons={buttons()}
                                    listButtons={listaBotones()}
                                    body={lista}
                                    head={head}
                                    rowSet={(e) => { setRowBean(e) }}
                                    pageTop={paginador.page}
                                    next={paginador.next}
                                    back={paginador.back}
                                    records={paginador}
                                />
                            </div>
                            <div className="col-md-12">
                                <Modal modal={consultar} updateModal={setconsultar}>
                                    <>
                                        <BudgetListForRefund />
                                    </>
                                </Modal>
                            </div>
                            <div className="col-md-12">
                                <Modal modal={moneybase} updateModal={setmoneybase} eventModal={createMoneyBaseForCashDeskAccount}>
                                    <div className="row">
                                        <div className="col-md-12">
                                            <CashDeskAccountSelector id={_createMoney.bean.IDCashDeskAccount} onchange={(e) => { _createMoney.setBean({ ..._createMoney.bean, "IDCashDeskAccount": e }) }} />
                                        </div>
                                        {_createMoney.bean.IDCashDeskAccount && <>
                                            <div className="col-md-6">
                                                <CDPCatalog year={_single.getCurrenYear()} idCashDeskAccount={_createMoney.bean.IDCashDeskAccount} idSelector={_createMoney.bean.IDCashDeskAccountCDP} onChange={(e) => { _createMoney.setBean({ ..._createMoney.bean, "IDCashDeskAccountCDP": e }) }} />
                                            </div>
                                        </>}
                                        <div className="col-md-6">
                                            <InputDate notDate label="Fecha" name="AccountantDate" value={_createMoney.bean.AccountantDate} setDate={(e) => { _createMoney.setBean({ ..._createMoney.bean, "AccountantDate": e }) }} />
                                        </div>
                                        <div className="col-md-12">
                                            <label>Observaciones</label>
                                            <textarea className="form-control" name='Observations' value={_createMoney.bean.Observations} onChange={_createMoney.handleChange} />
                                        </div>
                                    </div>
                                </Modal>
                            </div>
                        </div>


                    </BasicPage>


                    <ModalConfirm modal={modalConfirm} updateModal={setModalConfirm} eventModal={eliminarItem}>
                        {bean.Description}
                    </ModalConfirm>

                    <Modal modal={modal} updateModal={setModal} eventModal={() => { validateData(); }} onSubmitLabel={`guardar`}>
                        <div className="row">
                            <div className="col-md-6">
                                <label className={`${missingFields.includes('Media') ? 'has-error' : ''}`}>Archivo a importar</label>
                                <FileInput
                                    Media={bean.Media}
                                    MediaContext={bean.MediaContext}
                                    label=" "
                                    onCreate={(e: any) => setBean({ ...bean, 'Media': e.Media, 'MediaContext': e.MediaContext })}
                                />
                            </div>
                            <div className="col-md-6">
                                <label className={`${missingFields.includes('IssueDate') ? 'has-error' : ''}`}>Fecha de la Factura</label>
                                <InputDate name="" value={bean.IssueDate} notDate setDate={(e) => { setBean({ ...bean, IssueDate: e }) }} />
                            </div>
                            <div className="col-md-6">
                                <label className={`${missingFields.includes('InvoiceID') ? 'has-error' : ''}`}>Número de Factura</label>
                                <input type="text" className="form-control" value={bean.InvoiceID} onChange={(e) => { setBean({ ...bean, InvoiceID: e.target.value }) }} />
                            </div>
                            <div className="col-md-6">
                                <label className={`${missingFields.includes('PaymentValue') ? 'has-error' : ''}`}>Valor Solicitado</label>
                                <InputMoney _label=" " _value={bean.PaymentValue} onChange={(e) => { setBean({ ...bean, "PaymentValue": e }) }} />
                            </div>
                            <div className="col-md-6">
                                <label className={`${missingFields.includes('IDProject') ? 'has-error' : ''}`}>Proyecto</label>
                                <SelectProject
                                    label=" "
                                    idSelector={bean.IDProject}
                                    onChange={(value) => {
                                        if (!value) {
                                            setBean({
                                                ...bean,
                                                IDProject: null,
                                                IDBusinessCore: null
                                            });
                                            return;
                                        }

                                        const { IDProject, IDBusinessCore } = value;
                                        setBean({
                                            ...bean,
                                            IDProject: IDProject ?? null,
                                            IDBusinessCore: IDBusinessCore ?? null
                                        });
                                    }}
                                    returnType="Object"
                                />

                            </div>
                            <div className="col-md-6">
                                <label className={`${missingFields.includes('IDBusinessCore') ? 'has-error' : ''}`}>Core de Negocio</label>
                                <SelectBusinessCore label=" " idSelector={bean.IDBusinessCore} onChange={(e) => { setBean({ ...bean, "IDBusinessCore": e }) }} />
                            </div>
                            <div className="col-12">
                                <label className={`${missingFields.includes('Observations') ? 'has-error' : ''}`}>Observaciones</label>
                                <textarea value={bean.Observations} name="Observations" className="form-control" onChange={handleChange} rows={4} />
                            </div>
                        </div>
                    </Modal>
                    <div className="col-md-12">
                        <Modal modal={legalizar} updateModal={setlegalizar}>
                            <div className="row">
                                <div className="col-md-12">
                                    <DocumentViewer
                                        list={docs}
                                        IDDocument={bean.FCIDDocument}
                                        Since={bean.FCDate}
                                    />
                                </div>
                            </div>
                        </Modal>
                    </div>
                    <Modal modal={modalProcess} updateModal={setModalProcess} eventModal={procesItem} >
                        <div className="col-12">
                            <label>Observaciones</label>
                            <textarea value={obs} name="Observations" className="form-control" onChange={(e) => { setObs(e.target.value) }} rows={4} />
                        </div>
                    </Modal>


                    <Modal modal={modalAddToCashReimbursement} updateModal={setModalAddToCashReimbursement} eventModal={createUBLInvoice} >
                        <div className="row">
                            <div className="col-md-12">
                                <AccountEditor idAccount={bean.IDAccountSupplier} label="Provedor" onChange={(e) => { setBean({ ...bean, IDAccountSupplier: e.IDAccount }) }} />
                            </div>
                            <div className="col-md-12">
                                <label className={`${missingFields.includes('IDProject') ? 'has-error' : ''}`}>Proyecto</label>
                                <SelectProject
                                    label=" "
                                    idSelector={bean.IDProject}
                                    onChange={(value) => {
                                        if (!value) {
                                            setBean({
                                                ...bean,
                                                IDProject: null,
                                                IDBusinessCore: null
                                            });
                                            return;
                                        }

                                        const { IDProject, IDBusinessCore } = value;
                                        setBean({
                                            ...bean,
                                            IDProject: IDProject ?? null,
                                            IDBusinessCore: IDBusinessCore ?? null
                                        });
                                    }}
                                    returnType="Object"
                                />

                            </div>
                            <div className="col-md-12">
                                <label className={`${missingFields.includes('IDBusinessCore') ? 'has-error' : ''}`}>Core de Negocio</label>
                                <SelectBusinessCore label=" " idSelector={bean.IDBusinessCore} onChange={(e) => { setBean({ ...bean, "IDBusinessCore": e }) }} />
                            </div>

                        </div>
                    </Modal>

                    <Modal modal={modalDoc.modal} updateModal={modalDoc.setModal} >
                        <div className="col-md-12">
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="iframe-container">

                                        {fileType ?
                                            <>
                                                {fileType === 'pdf' && (
                                                    urlFile ? (
                                                        <>
                                                            aqui
                                                            <iframe name="pdfviwer" src={urlFile} onError={(e) => console.error('Error loading PDF:', e)}></iframe>
                                                        </>
                                                    ) : (
                                                        <p>Cargando PDF...</p>
                                                    )
                                                )}
                                                {fileType === `"jpg"` || fileType === "png" &&
                                                    (
                                                        <img src={urlFile} alt="Image Preview" width="100%" />
                                                    )
                                                }
                                                {fileType !== "pdf" && "jpg" && "png" &&
                                                    <>
                                                        <a href={donwloadURL} target='_blank'>Clic aquí para descargar el archivo {bean.Media}</a>
                                                    </>
                                                }
                                            </>
                                            :
                                            <>
                                                No se pudo cargar el Documento
                                            </>
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Modal >

                    <Modal modal={modalReject} updateModal={setModalReject} eventModal={rejectItem} >
                        <div className="col-12">
                            <label>Observaciones</label>
                            <textarea value={obs} name="Observations" className="form-control" onChange={(e) => { setObs(e.target.value) }} rows={4} />
                        </div>
                    </Modal>
                    <Modal modal={modalDownload.modal} updateModal={modalDownload.setModal}>
                        <div className="row">
                            <div className="col-md-12">
                                {listaAll.length > 0 &&
                                    <ExportXLSL customName={'legalizar'} optionIcon="ri-download-cloud-2-line text-success" title={head} data={listaAll} onExport={(name: string) => {
                                        _single.download("formato xlsx [" + name + "] con " + lista.length + " registros");
                                    }} />
                                }
                            </div>
                        </div>
                    </Modal>
                    <Modal modal={modalAccount.modal} updateModal={modalAccount.setModal} eventModal={() => {
                        if (dateAcc) {
                            accountUBL()
                        } else {
                            toast.error("Debe seleccionar una fecha para contabilizar el documento");
                        }
                    }} >
                        <div className="row">
                            <div className="col-md-12">
                                <InputDate name="" value={dateAcc} setDate={(e) => { setDateAcc(e) }} />
                            </div>
                        </div>
                    </Modal>

                    <Modal modal={modalSeeInvoice} updateModal={setModalSeeInvoice} >
                        <>
                            <SeeInvoice idInvoice={bean.IDUBLInvoice} issueDate={bean.IssueDate} />
                        </>
                    </Modal>

                    <Modal modal={modalUBL.modal} updateModal={modalUBL.setModal} eventModal={() => {
                        if (ubl.bean.IDUBLInvoice) {
                            updateInvoice();
                        }
                    }}  >
                        <div className="row">
                            <div className="col-md-12">
                                <UBLInvoiceSupplier isChash={true} externaUBLS={listUBL} />
                            </div>
                        </div>
                    </Modal>
                </div>
            </div>

        </>
    )
}